import React from "react";
import { Wallet, ArrowRight } from "lucide-react";

const Salaries = () => {
  return (
    <div className="bg-white h-full flex flex-col">
      {/* Header Section */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-[#E5E7EB]">
        <h1 className="text-2xl font-semibold font-outfit text-[#374151]">
          Salary Management
        </h1>
      </div>

      {/* Coming Soon Content */}
      <div className="flex flex-col p-6 max-w-7xl mx-auto w-full">
        <div className="flex mb-8 border-b border-[#E5E7EB] pb-6">
          <div className="w-16 h-16 bg-[#F3F2FF] rounded-full flex items-center justify-center mr-6 flex-shrink-0">
            <Wallet size={32} className="text-[#5652B0]" />
          </div>
          <div className="flex flex-col items-start text-left">
            <h2 className="text-2xl font-bold text-[#374151] mb-3 text-left">
              Coming Soon
            </h2>
            <p className="text-[#4B5563] text-base leading-relaxed text-left">
              We're developing a comprehensive Salary Management system to help
              you track employee compensation, manage payroll, and streamline
              your salary disbursement process.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-b from-[#FFFFFF] to-[#F9FAFB] border border-[#E5E7EB] rounded-xl p-6 w-full shadow-sm">
          <h3 className="text-xl font-semibold text-[#374151] mb-4 border-b border-[#EFF1F5] pb-2">
            This module will include:
          </h3>

          <div className="grid grid-cols-2 gap-4">
            <div className="flex items-start group hover:bg-[#F9F9FF] p-3 rounded-lg transition-all duration-200">
              <div className="mr-3 mt-1 bg-[#F3F2FF] p-1 rounded-full group-hover:bg-[#5652B0]">
                <ArrowRight
                  size={16}
                  className="text-[#5652B0] group-hover:text-white"
                />
              </div>
              <div>
                <p className="font-semibold text-[#4B5563] text-base group-hover:text-[#5652B0]">
                  Employee Salary Profiles
                </p>
                <p className="text-[#6B7280] text-sm leading-relaxed">
                  Maintain detailed salary information for each employee
                  including base pay, allowances, and deductions.
                </p>
              </div>
            </div>

            <div className="flex items-start group hover:bg-[#F9F9FF] p-3 rounded-lg transition-all duration-200">
              <div className="mr-3 mt-1 bg-[#F3F2FF] p-1 rounded-full group-hover:bg-[#5652B0]">
                <ArrowRight
                  size={16}
                  className="text-[#5652B0] group-hover:text-white"
                />
              </div>
              <div>
                <p className="font-semibold text-[#4B5563] text-base group-hover:text-[#5652B0]">
                  Payroll Processing
                </p>
                <p className="text-[#6B7280] text-sm leading-relaxed">
                  Generate and process monthly payroll with automated
                  calculations for taxes and other deductions.
                </p>
              </div>
            </div>

            <div className="flex items-start group hover:bg-[#F9F9FF] p-3 rounded-lg transition-all duration-200">
              <div className="mr-3 mt-1 bg-[#F3F2FF] p-1 rounded-full group-hover:bg-[#5652B0]">
                <ArrowRight
                  size={16}
                  className="text-[#5652B0] group-hover:text-white"
                />
              </div>
              <div>
                <p className="font-semibold text-[#4B5563] text-base group-hover:text-[#5652B0]">
                  Salary History
                </p>
                <p className="text-[#6B7280] text-sm leading-relaxed">
                  Track salary revisions, increments, and historical payment
                  data for all employees.
                </p>
              </div>
            </div>

            <div className="flex items-start group hover:bg-[#F9F9FF] p-3 rounded-lg transition-all duration-200">
              <div className="mr-3 mt-1 bg-[#F3F2FF] p-1 rounded-full group-hover:bg-[#5652B0]">
                <ArrowRight
                  size={16}
                  className="text-[#5652B0] group-hover:text-white"
                />
              </div>
              <div>
                <p className="font-semibold text-[#4B5563] text-base group-hover:text-[#5652B0]">
                  Payroll Reports
                </p>
                <p className="text-[#6B7280] text-sm leading-relaxed">
                  Generate comprehensive reports for salary expenses,
                  department-wise costs, and employee payment summaries.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Salaries;
